export const GET_BANK_DETAILS_DATA = 'GET_BANK_DETAILS_DATA'
export const CLEAR_BANK_DETAILS_DATA = 'CLEAR_BANK_DETAILS_DATA'